<template>
  <div>
    <div class="bg-div"></div>
    <div class="frd_list_cnt">
      <div class="frd_list_title">
        <div>推荐好友</div>
        <div>注册时间</div>
      </div>
      <div class='b_fff frd_list' v-for="(item, index) in dataList" :key="index">
        <div class='frd_list_left'>
          <img :src="item.HeadPortraitUrl === null ? require('@/assets/icon/defaultHead.png') : item.HeadPortraitUrl" />
          <div v-if="item.Nick">{{item.Nick | filtersText}}</div>
          <div v-else>{{item.LoginName | phoneEncode}}</div>
        </div>
        <div class='t_999'>
          <span :class="{'frd_btn': true, 'active': item.IsWaitReceive}">{{item.IsWaitReceive ? '下单' : '注册'}}</span>
          {{item.CreateTime | formatTime}}
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'RegisterItem',
  data () {
    return {
    }
  },
  props: {
    dataList: {
      type: Array,
      require: true,
      default () {
        return []
      }
    }
  },
  filters: {
    formatTime (val) {
      return moment(val).format('YYYY-MM-DD')
    },
    phoneEncode (val) {
      if (!val) return '----'
      let star = val.substring(0, 3)
      let end = val.substring(val.length - 4, val.length)
      return star + '****' + end
    },
    filtersText (val) {
      if (!val) return '----'
      let len = 0
      for (let i = 0; i < val.length; i++) {
        let char = val.charAt(i)
        if (/\w/.test(char)) {
          len += 0.5
        } else {
          len += 1
        }
        if (len > 6) {
          val = val.slice(0, i) + '...'
          break
        }
      }
      return val
    }
  }
}
</script>

<style scoped>
  .rmd_list_top{
    display: flex;
    padding:0px 15px 0px 15px;
    height: 42px;
    line-height: 42px;
    background: #F2F2F2;
    box-sizing: border-box;
    font-size: 13px;
  }
  .rmd_list_top .icon{
    margin-right: 5px;
  }
  .frd_list_cnt{
    padding: 0 16px;
  }
  .frd_list_title{
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #999;
    border-bottom: 1px solid #f6f6f6;
  }
  .frd_list_title > div{
    height: 40px;
    line-height: 40px;
    flex-grow: 1;
  }
  .frd_list_title > div:first-child{
    padding-left: 6%;
  }
  .frd_list_title > div:last-child{
    text-align: right;
    padding-right: 2%;
  }
  .frd_list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f6f6f6;
  }
  .frd_list_left{
    display: flex;
    align-items: center;
  }
  .frd_list_left img{
    width: 45px;
    height: 45px;
    border-radius: 100%;
    margin: 0 15px 0 10px;
  }
  .frd_btn{
    color: #999;
    background: #E6E6E6;
    display: inline-block;
    border-radius: 3px;
    padding: 1px 4px;
    margin-right: 10px;
  }
  .frd_btn.active{
    color: #FF9A00;
    background: #FBEDC0;
  }
  .bg-div{
    height: 10px;
    background: #F2F2F2;
  }
</style>
